import request from './HttpService';
import { ENDPOINTS } from '../utils/constants';

export const getUserRoles = async (query: string) => {
  const response = await request.get(`${ENDPOINTS.getPermissions}?query=${query}`);
  console.log('getUserRoles API response:', response.data);
  return response.data.data;
};
